import { forwardRef, type Ref, type SVGProps } from "react";
const IconTopAgentSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="#F2B100" d="M23 16.3H9V30l7-3.41L23 30z" />
    <path
      fill="#0041D9"
      d="M25.89 11.16c-.2-1.08.39-2.48-.15-3.48-.51-.95-1.99-1.23-2.81-2.02-.83-.79-1.18-2.26-2.15-2.73-1.01-.49-2.37.18-3.46.03-1.1-.14-2.24-1.13-3.33-.93-1.08.2-1.8 1.53-2.78 2.06-.95.52-2.46.4-3.24 1.22-.79.83-.58 2.34-1.05 3.32-.48 1.02-1.76 1.8-1.9 2.9-.15 1.1.89 2.2 1.09 3.3s-.4 2.5.14 3.49c.52.95 2 1.23 2.82 2.02s1.17 2.26 2.15 2.73c1 .48 2.37-.18 3.46-.03 1.1.14 2.24 1.13 3.33.93 1.08-.2 1.8-1.53 2.78-2.06.95-.52 2.45-.39 3.24-1.22s.58-2.34 1.04-3.32c.49-1.02 1.77-1.8 1.92-2.9.14-1.11-.9-2.2-1.1-3.3Z"
    />
    <path fill="#001962" d="M16 21.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17" />
    <path
      fill="#FFF"
      d="M17.44 10.42c.04-.01.06 0 .09.03l.72.86c.02.02.01.05 0 .07h-.01a16.4 16.4 0 0 0-2.5 2.47 29 29 0 0 1 4.36-1.33v-1.27l-.01-.03L16.03 8a.04.04 0 0 0-.05 0l-4.06 3.2a.04.04 0 0 0-.02.04v1.36c0 .03.03.05.06.03 1.3-.76 4.18-1.9 5.49-2.22Z"
    />
    <path
      fill="#FFF"
      d="M14.11 15.99a.07.07 0 0 1-.09-.02l-.77-.9c-.02-.03-.02-.04 0-.08a14.4 14.4 0 0 1 2.57-2.8 34 34 0 0 0-3.92 1.74v3.03c0 .02.01.04.04.04h8.12c.02 0 .04-.02.04-.04v-2.9a.04.04 0 0 0-.05-.03 30.4 30.4 0 0 0-5.94 1.96"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTopAgentSVG);
ForwardRef.displayName = "IconTopAgent";
export { ForwardRef as IconTopAgent };
